import { render, staticRenderFns } from "./PlatformTelegramConnection.vue?vue&type=template&id=67f6cd5d&scoped=true&"
import script from "./PlatformTelegramConnection.vue?vue&type=script&lang=js&"
export * from "./PlatformTelegramConnection.vue?vue&type=script&lang=js&"
import style0 from "./PlatformTelegramConnection.vue?vue&type=style&index=0&id=67f6cd5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f6cd5d",
  null
  
)

export default component.exports